import { useEffect } from "react";
import Loading from "shared/components/Spin";

const CollectionNeeds = ({ project, onNext }) => {
  useEffect(() => {
    onNext({
      payload: {
        fields: {
          ...project.fields,
          needs: {},
          selectedLevel: 1,
        },
      },
    });
  }, []);

  return <Loading />;
};

export default CollectionNeeds;
